import React from "react";
import { Box, Typography, Container, Grid, CardContent } from "@mui/material";
import trustedPlatformIcon from "../../../assets/icons/trusted-platform.svg";
import simplifiedEngagementIcon from "../../../assets/icons/simplified-engagement.svg";
import professionalSupportIcon from "../../../assets/icons/professional-support.svg";
import flexibleServiceOfferingsIcon from "../../../assets/icons/flexible-service-offerings.svg";
import tailoredSolutionsIcon from "../../../assets/icons/tailored-solutions.svg";
import qualifiedLeadsIcon from "../../../assets/icons/qualified-leads.svg";
import HighlightText from "../../../common/components/card-home-component/HighlightText";
const itemStyle = {
  padding: "16px",
  textAlign: "center",
  color: "#000",
  marginBottom: "2rem",
};
export const whyChooseMemorialGoFirstRowData = [
  {
    icon: <img src={trustedPlatformIcon} alt="Trusted Platform" />,
    title: "Trusted Platform",
    description:
      "Be part of a carefully curated platform families rely on when seeking funeral and memorial services.",
  },
  {
    icon: <img src={simplifiedEngagementIcon} alt="Simplified Engagement" />,
    title: "Simplified Engagement",
    description:
      "Manage inquiries and coordination through a clear, structured process that fits existing workflows.",
  },
  {
    icon: <img src={qualifiedLeadsIcon} alt="Qualified Leads" />,
    title: "Qualified Leads",
    description:
      "Connect with families who are actively seeking the services you provide.",
  },
];
const whyChooseMemorialGoSecondRowData = [
  {
    icon: <img src={professionalSupportIcon} alt="Professional Support" />,
    title: "Professional Support",
    description:
      "Support is available throughout onboarding and ongoing participation.",
  },
  {
    icon: (
      <img
        src={flexibleServiceOfferingsIcon}
        alt="Flexible Service Offerings"
      />
    ),
    title: "Flexible Service Offerings",
    description:
      "Present services in a way that reflects unique offerings, traditions, and areas of expertise.",
  },
];
function WhyChooseUs() {
  return (
    <Box
      sx={{ padding: "2rem", backgroundColor: "#fff", fontFamily: "Roboto" }}
    >
      <Typography
        variant="h4"
        component="h2"
        sx={{
          textAlign: "center",
          marginBottom: "2rem",
          fontWeight: 600,
          fontSize: { xs: "24px", md: "32px", lg: "34px" },
          lineHeight: { xs: "28px", md: "36px", lg: "40px" },
          color: "#104145",
        }}
      >
        Why <span style={{ color: "#9F7F2C" }}>Choose MemorialGo</span>
      </Typography>
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <Grid container spacing={2}>
          {whyChooseMemorialGoFirstRowData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <CardContent>
                <Box className="cardContent">
                  <Box className="icon">{card.icon}</Box>

                  <Typography variant="h6" className="title-heading">
                    {card.title}
                  </Typography>

                  <Typography variant="body2" className="description">
                    <HighlightText
                      text={card.description}
                      highlight={"MemorialGo"}
                    />
                  </Typography>
                </Box>
              </CardContent>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Container
        maxWidth="lg"
        sx={{
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "73%",
            xl: "73%",
          },
          maxWidth: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "73%",
            xl: "73%",
          },
          minWidth: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "73%",
            xl: "73%",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          {whyChooseMemorialGoSecondRowData.map((card, index) => (
            <Box
              key={index}
              sx={{
                flex: "1 1 300px",
                maxWidth: 350,
                minWidth: 250,
                m: 1,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CardContent>
                <Box className="cardContent">
                  <Box className="icon">{card.icon}</Box>

                  <Typography variant="h6" className="title-heading">
                    {card.title}
                  </Typography>

                  <Typography variant="body2" className="description">
                    <HighlightText
                      text={card.description}
                      highlight={"MemorialGo"}
                    />
                  </Typography>
                </Box>
              </CardContent>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default WhyChooseUs;
